import React from 'react';
import { default as VALIDATORS } from './validations';

import RadioGroup, { Radio } from './atoms/radio';

import Form from './atoms/form';
import Button from './atoms/button';
import Input from './atoms/input';

const IO = {
  Button: props => <Button type="button" {...props} />,
  ButtonToggle: props => <Button type="button" isToggle={true} {...props} />,
  Email: props => (
    <Input type="email" validation={VALIDATORS.email} {...props} />
  ),
  Form: props => <Form {...props} />,
  RadioGroup: props => <RadioGroup {...props} />,
  Radio: props => <Radio {...props} />,
  Password: props => (
    <Input type="password" validation={VALIDATORS.password} {...props} />
  ),
  ReadOnly: props => <Input type="text" readonly {...props} />,
  Text: props => <Input type="text" {...props} />,
  Username: props => (
    <Input type="text" validation={VALIDATORS.username} {...props} />
  ),
  Url: props => <Input type="text" validation={VALIDATORS.url} {...props} />,
};

export default IO;
